import { Component, EventEmitter, Input, OnChanges, Output} from '@angular/core';
import { NgClass } from '@angular/common';
import { SpanTooltipComponent } from '../span-tooltip/span-tooltip.component';

@Component({
    selector: 'filter-by-order',
    templateUrl: './filter-by-order.component.html',
    standalone: true,
    imports: [SpanTooltipComponent, NgClass]
})
export class FilterByOrderComponent implements OnChanges{
  filterByOrder: any = {
    label: '',
  }
  constructor() { }

  @Input() item: any;
  @Input() filterOrder: string | any;
  @Input() order: boolean = false;

  @Output() launchActionFilterOrderEmit = new EventEmitter();

  ngOnChanges(): void {
    if(this.item){
      this.filterByOrder.label = this.item.textColumn?this.item.textColumn:this.item.name;
    }
  }

  orderColumn(){
      this.launchActionFilterOrderEmit.emit({newValue: this.item.filterOrder, action: 'order'});
  }

}
